import React from 'react';
import { Nav, Navbar } from 'reactstrap';

import { useAppSelector } from '../../../reduxstore/hooks';
import fallbackData from '../../assets/fallback-menu.json';
import { Brand } from './Brand';
import { Item } from './Item';

const shopLinkData = {
	label: 'Shop',
	target: '_blank',
	url: 'https://store.bhappylounge.com/',
	pixel: 'https://insight.adsrvr.org/track/pxl/?adv=xwyhvtq&ct=0:0zsbhvf&fmt=3',
	childItems: {
		nodes: []
	}
};

const authLoginLink = 'https://accounts.biggby.com/storefrontLogin/';

export const NavBar: React.FC = () => {
	const { menu } = fallbackData.data;

	const authenticated = useAppSelector(
		state => state.authReducer.accessToken
	);

	return (
		<Navbar
			light
			expand
			className="d-none d-lg-flex border-bottom border-dark py-3 px-3 header-nav-bar w-100"
		>
			<div className="container mx-auto align-items-center d-flex">
				<Brand />
				<Nav className="ml-auto" navbar>
					{menu.menuItems.nodes.map(node => (
						<Item {...node} key={node.label} />
					))}
					<Item
						url={authenticated ? authLoginLink : shopLinkData.url}
						label={shopLinkData.label}
						target={shopLinkData.target}
						isLast={true}
						childItems={shopLinkData.childItems}
						pixel={shopLinkData.pixel}
					/>
				</Nav>
			</div>
		</Navbar>
	);
};
